import React, { useContext, useEffect, useState } from "react";
import classes from "./UpdateBirthdate.module.scss";
import { useNavigate } from "react-router";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import "react-datepicker/dist/react-datepicker.css";
import RoundButton from "../../../../components/Buttons/RoundButton";
import { useTranslation } from "react-i18next";
import Alert from "../../../../components/Alerts";
import useFetch from "../../../../hooks/useFetch";
import * as a from "../../../../constants/api";
import Spinner from "../../../../components/Spinner";
import SessionContext from "../../../../context/sessionContext";
import { R_U_WELCOME } from "../../../../constants/routes";
import InputMask from "react-input-mask";


export default function UpdateBirthdate() {
  const history = useNavigate();
  const [errorMsg, setErrorMsg] = useState("");
  const { t } = useTranslation();

  const [year, setYear] = useState(null as any);

  let validYear = false;

  const cSessions = useContext(SessionContext);

  const [response, isLoading, fetchError, fetch]: any = useFetch({
    autoInit: false,
    noAuth: true,
  });

  useEffect(() => {
    if (fetchError && fetchError.status === 401) {
      cSessions.sessionLogout(null);
    }
  }, [cSessions, fetchError]);

  const [year2, setYear2] = useState(null as any);

  useEffect(() => {
    if (response && cSessions && year2) {
      cSessions.setPublicUserBirthdate(
        year2.getFullYear() + "-" + (year2.getMonth() + 1),
        response.token
      );
      history(R_U_WELCOME);
    }
  }, [cSessions, response, year2, history]);

  const postBirthdateHandler2 = () => {
    setErrorMsg("")
    const date2: string = (
      document.getElementById("datepicker") as HTMLInputElement
    ).value;
    const date: string = date2.split("/").reverse().join("-");
    const addDay = (date: string, d: number) => {
      const result = new Date(date);
      result.setDate(result.getDate() + d);
      return result;
    };

    const dateAux = addDay(date, 1);

    setYear2(dateAux);
    if (!isNaN(dateAux.getFullYear()) && !isNaN(dateAux.getMonth())) {
      const birthdate = dateAux.getFullYear() + "-" + (dateAux.getMonth() + 1);
      const { user } = cSessions ?? { user: { token: null } };
      if (user && user.token) {
        fetch({
          method: "POST",
          url: a.API_USER_BIRTHDATE,
          data: {
            birthdate,
          },
          noAuth: true,
          header: {
            userauthorization: user.token,
          },
        });
      }
    } else {
      setErrorMsg(t("infos.birthdate_model_error"));
    }
  };

  let _alert = null;
  let _content = null;

  if (year) {
    validYear =
      new Date().getFullYear() - 4 > year.getFullYear() &&
      new Date().getFullYear() - year.getFullYear() < 120;
  }

  if (isLoading) {
    _content = <Spinner center />;
  } else {
    if (fetchError) {
      _alert = <Alert text={t("infos.error_saving")} closeBtn={false} danger />;
    } else if (!validYear && year)
      _alert = (
        <Alert text={t("infos.not_valid_birthdate")} closeBtn={false} danger />
      );
    _content = (
      <>
        {_alert}

        <section className={classes.UpdateBirthdate}>
          <InputMask
            data-placeholder={"mês e ano de nascimento"}
            mask="99/9999"
            type="text"
            value={year}
            id="datepicker"
            inputmode="numeric"
            onChange={setYear2}
          />
        </section>
        <RoundButton
          onClick={postBirthdateHandler2}
          disabled={!year2}
          className={classes.BtnConfirm}
          text={t("global.confirm")}
          title={t("global.confirm")}
        />
      </>
    );
  }
  return (
    <>
      <PageHeader
        title={t("global.first_step")}
        subtitle={t("global.update_your_birthdate_info")}
      />
      {errorMsg && <div className={classes.ErrorMsgBirthdate}>{errorMsg}</div>}
      <div className={classes.UpdateBirthdateContainer}>
        {_content}
      </div>
    </>
  );
}
